import _ from 'underscore';

export default class List {
  constructor(data) {
    // Programmatically assign properties from api data
    _.chain(data).keys().forEach(key => (data[ key ] && (this[ key ] = data[ key ])));
  }

  hasName() {
    return !_.isEmpty(this.name);
  }

  hasUniqueName(lists) {
    if (this.hasName()) {
      return !_.any(lists, otherList => {
        return otherList ? (otherList.name === (this.name).trim() && otherList.id !== this.id) : false;
      });
    }

    return false;
  }

  isValid(otherLists) {
    return Boolean(this.hasUniqueName(otherLists) && !!this.userId);
  }
}


// WEBPACK FOOTER //
// ./src/js/FastRecruit/models/List.js